// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + {"571":"daa2a51fa63b0216","873":"ac06817b38c65ea5"}[chunkId] + ".css";
};